import React, { useEffect, useRef, useState } from "react";
import { shippingService } from "../services/dataService";
import "../pages/PurchaseOrders.css";
import "../pages/Shipping.css";

export interface ShipmentPrintModalProps {
  shipmentId: string;
  number: string;
  onClose: () => void;
}

const I = {
  close: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 6l12 12M18 6 6 18" /></svg>,
  print: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" /><path d="M6 14h12v7H6z" /></svg>,
};

/** Sevk irsaliyesi önizlemesi: sunucunun yazdırma HTML'i iframe'de; Yazdır tarayıcının yazdırma penceresini açar. */
const ShipmentPrintModal: React.FC<ShipmentPrintModalProps> = ({ shipmentId, number, onClose }) => {
  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState("");
  const [attempt, setAttempt] = useState(0);
  const frameRef = useRef<HTMLIFrameElement>(null);
  const printRef = useRef<HTMLButtonElement>(null);
  const [opener] = useState(() => document.activeElement as HTMLElement | null);

  useEffect(() => {
    let live = true;
    setHtml(null); setError("");
    shippingService.printHtml(shipmentId)
      .then((h) => { if (live) setHtml(h); })
      .catch(() => { if (live) setError("Yazdırma görünümü alınamadı."); });
    return () => { live = false; };
  }, [shipmentId, attempt]);

  useEffect(() => { if (html) printRef.current?.focus(); }, [html]);
  useEffect(() => () => { if (opener && opener.isConnected) opener.focus?.({ preventScroll: true }); }, [opener]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") { e.stopPropagation(); onClose(); } };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [onClose]);

  const print = () => { frameRef.current?.contentWindow?.focus(); frameRef.current?.contentWindow?.print(); };
  // Yazdır'dan sonra odak iframe'de kalır; Esc oradan da kapatsın (srcDoc aynı köken)
  const onFrameLoad = (e: React.SyntheticEvent<HTMLIFrameElement>) =>
    e.currentTarget.contentDocument?.addEventListener("keydown", (k) => { if (k.key === "Escape") onClose(); });

  return (
    <div className="po-overlay center top" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="po-modal wide sh-print" role="dialog" aria-modal="true" aria-labelledby="sh-print-title">
        <div className="po-modal-head">
          <div><span className="po-kicker">{number}</span><h3 id="sh-print-title">Sevk irsaliyesi</h3></div>
          <button type="button" className="po-ib big" aria-label="Kapat" onClick={onClose}>{I.close}</button>
        </div>

        <div className="po-modal-body">
          {!html && !error && <div className="po-loading"><span className="po-spin" /> Yazdırma görünümü hazırlanıyor</div>}
          {error && <div className="po-note err" role="alert">{error} <button type="button" className="po-link" onClick={() => setAttempt((a) => a + 1)}>Yeniden dene</button></div>}
          {html && <iframe ref={frameRef} className="sh-print-frame" title="Sevk irsaliyesi" srcDoc={html} onLoad={onFrameLoad} />}
        </div>

        <div className="po-modal-foot between">
          <span className="po-hint">A4 dikey · tarayıcı yazdırma penceresi açılır</span>
          <div className="po-foot-btns">
            <button type="button" className="po-btn" autoFocus onClick={onClose}>Kapat</button>
            <button type="button" ref={printRef} className="po-btn primary" disabled={!html} onClick={print}>{I.print} Yazdır</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShipmentPrintModal;
